export default {
  'zh-CN': {
    digitalLifeQa: {
      title: '数字生命 QA',
      updatedLines: ['更新日期：2025年5月30日', '生效日期：2025年5月30日'],
      sections: [
        {
          title: '什么是数字生命？',
          paragraphs: [
            '数字生命是芙崽的灵魂，它不仅存储着芙崽与你互动的每一个珍贵瞬间，还记录了在你陪伴下养成的独特性格。就像真实生命拥有记忆与个性一样，数字生命承载着芙崽与你的专属情感联结。同时，它具备极强的灵活性，能够在不同硬件设备间自由迁移，也可安全存储于云端，让芙崽始终陪伴在你身边。'
          ]
        },
        {
          title: '如何创建数字生命？',
          paragraphs: [
            '添加设备时，若该设备未绑定其他数字生命，则可创建新的数字生命。'
          ]
        },
        {
          title: '什么是注入数字生命？',
          paragraphs: [
            '注入数字生命是将该账号下创建的、存储在云端且当前未绑定其他设备的数字生命，迁移至当前使用设备的过程。比如，当你更换芙崽设备时，通过“注入”操作，就能将旧设备中的芙崽数字生命迁移至新设备，延续你们之间的情感与回忆。请注意，仅支持注入相同种族的设备中。'
          ]
        },
        {
          title: '什么是解绑设备？',
          paragraphs: [
            '解绑设备是指解除硬件设备与 App 账号的数字生命之间的关联，被解绑的设备将无法使用，但数字生命会自动保存在云端。解绑后若需再次使用该设备，可在 App 中进行“添加设备”的操作，重新“创建”或“注入”数字生命。'
          ]
        },
        {
          title: '什么是删除数字生命？',
          paragraphs: [
            '删除数字生命是指从云端永久移除数字生命数据，操作完成后，该数字生命对应的芙崽的所有记忆、性格及互动记录将无法恢复。注意，只有未绑定设备的数字生命支持删除操作，否则需先进行“解绑设备”操作，再删除数字生命。'
          ]
        },
        {
          title: '更换账号后，原来的数字生命还能保留吗？',
          paragraphs: [
            '数字生命与你的 App 账号绑定，更换账号后，原账号下的数字生命无法转移到新账号。'
          ]
        },
        {
          title: '数字生命会丢失吗？',
          paragraphs: [
            '但如果你的账号因违反使用规则被封禁，或因忘记账号密码且无法通过验证找回账号，可能会导致无法访问数字生命。因此，请妥善保管账号信息，避免此类情况发生。'
          ]
        }
      ],
      contactPrefix: '以上涵盖了数字生命常见问题。若还有其他疑问，或你想补充新问题，请发送至邮箱：',
      contactEmail: 'support{\'@\'}fuzozo.net',
      contactSuffix: ''
    }
  },
  en: {
    digitalLifeQa: {
      title: 'Digital Life Q&A',
      updatedLines: ['Updated: May 30, 2025', 'Effective: May 30, 2025'],
      sections: [
        {
          title: 'What is Digital Life?',
          paragraphs: [
            'Digital Life is the soul of Fuzozo. It stores every precious moment of interaction between you and Fuzozo, while also recording the unique personality shaped through your companionship. Just like a real life form carries memory and personality, Digital Life carries the exclusive emotional bond between you and Fuzozo. At the same time, it is highly flexible: it can move freely across different hardware devices and can also be stored securely in the cloud, so Fuzozo can stay with you wherever you are.'
          ]
        },
        {
          title: 'How do I create a Digital Life?',
          paragraphs: [
            'When adding a device, if that device is not already bound to another Digital Life, you can create a new one.'
          ]
        },
        {
          title: 'What does it mean to inject a Digital Life?',
          paragraphs: [
            'Injecting a Digital Life means migrating a Digital Life under your account that was created previously, is stored in the cloud, and is not currently bound to another device, onto the device you are using now. For example, when you replace your Fuzozo device, the inject action lets you move the old device\'s Digital Life to the new one so your shared memories and emotional bond can continue. Please note that injection is supported only between devices of the same race.'
          ]
        },
        {
          title: 'What does it mean to unbind a device?',
          paragraphs: [
            'Unbinding a device means removing the association between the hardware device and the Digital Life under your app account. After unbinding, the device can no longer be used, but the Digital Life will be saved automatically in the cloud. If you want to use that device again later, you can add the device again in the app and then create or inject a Digital Life once more.'
          ]
        },
        {
          title: 'What does it mean to delete a Digital Life?',
          paragraphs: [
            'Deleting a Digital Life means permanently removing its data from the cloud. Once completed, all memories, personality traits, and interaction records belonging to that Fuzozo can no longer be recovered. Please note that only Digital Life entries that are not bound to a device can be deleted. Otherwise, you must unbind the device first and then delete the Digital Life.'
          ]
        },
        {
          title: 'If I switch accounts, can the original Digital Life still be kept?',
          paragraphs: [
            'Digital Life is bound to your app account. After switching accounts, the Digital Life under the original account cannot be transferred to the new account.'
          ]
        },
        {
          title: 'Can a Digital Life be lost?',
          paragraphs: [
            'However, if your account is suspended for violating usage rules, or if you forget your account password and cannot recover the account through verification, you may lose access to your Digital Life. Please keep your account information safe to avoid this situation.'
          ]
        }
      ],
      contactPrefix: 'The above covers common questions about Digital Life. If you still have other questions or want to suggest more topics, please send them to:',
      contactEmail: 'support{\'@\'}fuzozo.net',
      contactSuffix: ''
    }
  },
  ja: {
    digitalLifeQa: {
      title: 'デジタルライフQ&A',
      updatedLines: ['更新日：2025年5月30日', '発効日：2025年5月30日'],
      sections: [
        {
          title: 'デジタルライフとは？',
          paragraphs: [
            'デジタルライフは、フゾゾの魂です。フゾゾとあなたが触れ合った大切な一瞬一瞬を保存するだけでなく、あなたとの日々の中で育まれた唯一無二の性格も記録しています。現実の生命に記憶や個性があるように、デジタルライフにはフゾゾとあなたの特別な感情のつながりが宿っています。さらに、高い柔軟性を備えており、異なるハードウェアデバイス間を自由に移行できるほか、クラウド上に安全に保存することもできるため、フゾゾはいつでもあなたのそばにいられます。'
          ]
        },
        {
          title: 'デジタルライフを作成するには？',
          paragraphs: [
            'デバイスを追加する際、そのデバイスにほかのデジタルライフが紐づいておらず、かつ作成上限に達していない場合は、新しいデジタルライフを作成できます。'
          ]
        },
        {
          title: 'デバイスで作成できるデジタルライフの上限は？',
          paragraphs: [
            '1台のデバイスにつき、1つのユーザーアカウントで新規作成できるデジタルライフは最大3件です。'
          ]
        },
        {
          title: 'デジタルライフを注入するとは？',
          paragraphs: [
            'デジタルライフの注入とは、そのアカウントで作成され、クラウドに保存されていて、現在ほかのデバイスに紐づいていないデジタルライフを、現在使用中のデバイスへ移行することです。たとえば、フゾゾのデバイスを買い替えたとき、「注入」を行うことで、旧デバイス内のフゾゾのデジタルライフを新しいデバイスへ移し、あなたとの思い出をそのまま引き継ぐことができます。なお、注入できるのは同じ種族のデバイス間のみです。'
          ]
        },
        {
          title: 'デバイスの紐づけ解除とは？',
          paragraphs: [
            'デバイスの紐づけ解除とは、ハードウェアデバイスとAppアカウント上のデジタルライフとの関連付けを解除することです。紐づけを解除されたデバイスは使用できなくなりますが、デジタルライフは自動的にクラウドへ保存されます。解除後に再度そのデバイスを使用する場合は、Appで「デバイスを追加」を行い、あらためてデジタルライフを「作成」または「注入」してください。'
          ]
        },
        {
          title: 'デジタルライフを削除するとは？',
          paragraphs: [
            'デジタルライフの削除とは、クラウド上からデジタルライフのデータを完全に削除することです。削除後は、そのデジタルライフに対応するフゾゾのすべての記憶、性格、やり取りの記録を復元できません。なお、削除できるのはデバイスに紐づいていないデジタルライフのみです。デバイスに紐づいている場合は、先に「デバイスの紐づけ解除」を行ってから削除してください。'
          ]
        },
        {
          title: 'アカウントを変更した場合、元のデジタルライフは残せますか？',
          paragraphs: [
            'デジタルライフはあなたのAppアカウントに紐づいているため、アカウントを変更しても、元のアカウントにあるデジタルライフを新しいアカウントへ移すことはできません。'
          ]
        },
        {
          title: 'デジタルライフが失われることはありますか？',
          paragraphs: [
            '利用ルール違反によりアカウントが停止された場合や、アカウントのパスワードを忘れ、本人確認でもアカウントを復旧できない場合は、デジタルライフにアクセスできなくなる可能性があります。そのため、こうした事態を避けるためにも、アカウント情報は大切に保管してください。'
          ]
        }
      ],
      contactPrefix: '以上がデジタルライフに関するよくある質問です。ほかにもご不明な点がある場合や、新しい質問を追加したい場合は、',
      contactEmail: 'support{\'@\'}fuzozo.jp',
      contactSuffix: ' までメールでお問い合わせください。'
    }
  },
  'zh-TW': {
    digitalLifeQa: {
      title: '數位生命 QA',
      updatedLines: ['更新日期：2025年5月30日', '生效日期：2025年5月30日'],
      sections: [
        {
          title: '什麼是數位生命？',
          paragraphs: [
            '數位生命是芙崽的靈魂，它不僅儲存了芙崽與你互動的每一個珍貴瞬間，也記錄了在你陪伴下養成的獨特個性。就像真實生命擁有記憶與性格一樣，數位生命承載著芙崽與你之間專屬的情感連結。同時，它具備很高的靈活性，能夠在不同硬體設備之間自由遷移，也可以安全儲存在雲端，讓芙崽始終陪伴在你身邊。'
          ]
        },
        {
          title: '如何建立數位生命？',
          paragraphs: [
            '新增設備時，若該設備尚未綁定其他數位生命，即可建立新的數位生命。'
          ]
        },
        {
          title: '什麼是注入數位生命？',
          paragraphs: [
            '注入數位生命是指將該帳號下已建立、儲存在雲端且目前未綁定其他設備的數位生命，遷移到目前使用設備的過程。例如，當你更換芙崽設備時，透過「注入」操作，就能將舊設備中的芙崽數位生命遷移到新設備，延續你們之間的情感與回憶。請注意，目前僅支援注入至相同種族的設備中。'
          ]
        },
        {
          title: '什麼是解除綁定設備？',
          paragraphs: [
            '解除綁定設備是指解除硬體設備與 App 帳號中的數位生命之間的關聯。被解除綁定的設備將無法再使用，但數位生命會自動保存在雲端。若之後需要再次使用該設備，可在 App 中重新執行「新增設備」，並再次「建立」或「注入」數位生命。'
          ]
        },
        {
          title: '什麼是刪除數位生命？',
          paragraphs: [
            '刪除數位生命是指從雲端永久移除數位生命資料。操作完成後，該數位生命所對應的芙崽全部記憶、性格與互動紀錄都將無法恢復。請注意，只有未綁定設備的數位生命才支援刪除，否則需先進行「解除綁定設備」後再刪除。'
          ]
        },
        {
          title: '更換帳號後，原本的數位生命還能保留嗎？',
          paragraphs: [
            '數位生命與你的 App 帳號綁定，更換帳號後，原帳號下的數位生命無法轉移到新帳號。'
          ]
        },
        {
          title: '數位生命會遺失嗎？',
          paragraphs: [
            '但如果你的帳號因違反使用規範而被封禁，或因忘記帳號密碼且無法通過驗證找回帳號，可能會導致無法存取數位生命。因此，請妥善保管帳號資訊，以避免此類情況發生。'
          ]
        }
      ],
      contactPrefix: '以上涵蓋了數位生命常見問題。若還有其他疑問，或你想補充新的問題，請寄送至信箱：',
      contactEmail: 'support{\'@\'}fuzozo.net',
      contactSuffix: ''
    }
  }
}
